module.exports = __webpack_public_path__ + "img/syukyaku-top-ira008.df955971.png";